function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillOpacity: 0.7,
  fill: "#df4e10",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M7.5 0C3.887 0 0 1.144 0 3.656v10.688C0 16.855 3.887 18 7.5 18c3.612 0 7.5-1.145 7.5-3.656V3.656C15 1.144 11.112 0 7.5 0zm6.429 14.344c0 1.397-2.879 2.531-6.429 2.531-3.55 0-6.429-1.134-6.429-2.531v-2.102c1.107 1.198 3.777 1.82 6.429 1.82s5.322-.622 6.429-1.82v2.102zm0-3.375h-.003l.003.017c0 1.389-2.879 2.514-6.429 2.514-3.55 0-6.429-1.125-6.429-2.514l.003-.017H1.07V8.867c1.107 1.198 3.777 1.82 6.429 1.82s5.322-.622 6.429-1.82v2.102zm0-3.375h-.003l.003.017c0 1.389-2.879 2.514-6.429 2.514-3.55 0-6.429-1.125-6.429-2.514l.003-.017H1.07V5.66C2.476 6.784 5.05 7.313 7.5 7.313c2.45 0 5.024-.529 6.429-1.652v1.933zM7.5 6.187c-3.55 0-6.429-1.134-6.429-2.53 0-1.4 2.878-2.532 6.429-2.532 3.55 0 6.429 1.133 6.429 2.531 0 1.397-2.879 2.531-6.429 2.531z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.321,
  cy: 14.625,
  rx: 1,
  ry: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.321,
  cy: 11.25,
  rx: 1,
  ry: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.321,
  cy: 7.875,
  rx: 1,
  ry: 1
}));

var SvgCompany = function SvgCompany(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompany, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company.5aa03a6f.svg";
export { ForwardRef as ReactComponent };